var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-67 -44 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #868686;\n        fill-rule: evenodd;\n        opacity: 0.54;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol_45",
    "data-name": "Symbol 45",
    transform: "translate(-188 -126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    className: "cls-1",
    d: "M20,11H7.8l5.6-5.6L12,4,4,12l8,8,1.4-1.4L7.8,13H20V11Z",
    transform: "translate(117 78)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBackArrow);
export default __webpack_public_path__ + "static/media/go_back_arrow.1520285ab95eaac8bd3cf2e9f87e3a3c.svg";
export { ForwardRef as ReactComponent };